import { simbaStyled } from '@naf-simba/theme';
import { Button } from '@naf-simba/elements-buttons';
import { spacing } from '@naf/theme';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  gap: ${spacing.space8};
  justify-content: center;
  align-items: center;
  margin-left: ${spacing.space8};
`;

export const StyledSimbaButton = simbaStyled<typeof Button, Record<string, never>>(Button)(() => ({
  '&&': {
    height: '44px',
    padding: `0 ${spacing.space16}`,
  },

  '& .naf-ButtonLabel': {
    fontSize: '1rem',
  },
}));
